import React from "react";

class Loading extends React.Component {
  render() {
    return (
      <div
        style={{
          position: "fixed",
          width: "500px",
          height: "200px",
          top: "50%",
          left: "50%",
          marginTop: "-100px",
          marginLeft: "-250px",
          backgroundColor: "white",
          border: "2px solid black",
          fontSize: "30px",
          zIndex: "999",
        }}
      >
        <h1>측정중입니다.</h1>
        <h1>잠시만 기다려 주십시오.</h1>
      </div>
    );
  }
}

export default Loading;
